/* 
  * To Title Case 2.1 – http://individed.com/code/to-title-case/
  * Copyright © 2008–2013 David Gouch. Licensed under the MIT License.
 */
// eslint-disable-next-line
String.prototype.toTitleCase = function (separator = ' ') {
    var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

    return this
        .split(/(?=[A-Z])/).map(str => str.trim())
        .join(separator)
        .replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
            if (index > 0 && index + match.length !== title.length &&
                match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                title.charAt(index - 1).search(/[^\s-]/) < 0) {
                return match.toLowerCase();
            }

            if (match.substr(1).search(/[A-Z]|\../) > -1) {
                return match;
            }

            return match.charAt(0).toUpperCase() + match.substr(1);
        });
};

// https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript
// eslint-disable-next-line
Number.prototype.formatMoney = function (c, d, t) {
    // eslint-disable-next-line
    d = d == undefined ? "." : d;
    // eslint-disable-next-line
    t = t == undefined ? "," : t;
    // eslint-disable-next-line
    var n = this,
        // eslint-disable-next-line
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        // eslint-disable-next-line
        d = d == undefined ? "." : d,
        // eslint-disable-next-line
        t = t == undefined ? "," : t,
        // eslint-disable-next-line
        s = n < 0 ? "-" : "",
        // eslint-disable-next-line
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        // eslint-disable-next-line
        j = (j = i.length) > 3 ? j % 3 : 0;
    // eslint-disable-next-line
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};